const url = 'https://jp.candyhouse.co';
const intro = `${url}/pages/sesamebiz-introduction-guide-new`;
const plans = `${url}/pages/sesame-biz-operation#biz_plans`;
const terms = `${url}/pages/sesamebiz_terms`;
const privacy = `${url}/pages/privacy_policy`;
const shop = `${url}/collections/frontpage`;
const appTerms = `${url}/pages/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84`;
const appPrivacy = `${url}/pages/privacy`;

export const URLs = {
  url,
  intro,
  plans,
  terms,
  privacy,
  shop,
  appTerms,
  appPrivacy,
};
